import { render, staticRenderFns } from "./QrCodeDisplay.vue?vue&type=template&id=28d3935b&scoped=true&"
import script from "./QrCodeDisplay.vue?vue&type=script&lang=js&"
export * from "./QrCodeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d3935b",
  null
  
)

export default component.exports